// extracted by mini-css-extract-plugin
export default {"header":"style--header--1ab34a"};